import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function enrollmentHasTest(id: number) {
  return restApiClient.url(constructApiUrl(API.enrollments.hasTest.url, { id })).get<boolean>()
}
